import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';
import type { ObservableDocumentExtension as ObservableDocumentModel } from 'tio-data/data/resources/observable-document.ext';

export default class AuthenticatedReimaginedDocumentsIndexRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const personId = this.sessionContext.person.id;

    let observableDocuments: ObservableDocumentModel[] = [];
    if (personId) {
      try {
        const { content } = (await this.store.request(
          query<ObservableDocumentModel>('observable-document', {
            'filter[person]': personId,
            include: 'observable-asset',
            sort: '-created-at',
            'page[limit]': 25,
          })
        )) as { content: { data: ObservableDocumentModel[] } };
        observableDocuments = [...content.data];
      } catch {
        // Fail gracefully — show the empty state.
      }
    }

    return { observableDocuments };
  }
}
